export default "__VITE_ASSET__afa15ee5__"